var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active-right-subtitle relative",style:({height: _vm.height + 'px'})},[_c('div',{staticClass:"active-right-subtitle-line hot-left absolute",style:({
        width: _vm.width + 'px',
        backgroundColor: _vm.backgroundColor,
        top: _vm.top + 'px'
    })}),_vm._t("default",function(){return [_c('div',{staticClass:"active-right-subtitle-text"},[_vm._v("HOT")])]}),_c('div',{staticClass:"active-right-subtitle-line hot-right absolute",style:({width: _vm.width + 'px',backgroundColor: _vm.backgroundColor,top: _vm.top+'px'})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }